import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useMemo } from 'react';
import { propStr } from '../../../../../helpers/custom-prop-types';
const ProfessionalUnitCompanyInformationArea = (props) => {
    const { area } = props;
    const areas = useMemo(() => area
        .split('\n')
        .filter((v) => v)
        .map((v, i) => ({ key: i, text: v })), [area]);
    if (!areas.length) {
        return null;
    }
    return (_jsxs("dl", Object.assign({ className: 'information_row' }, { children: [_jsx("dt", Object.assign({ className: 'information_label' }, { children: "\u5BFE\u5FDC\u30A8\u30EA\u30A2" })), _jsx("dd", Object.assign({ className: 'information_value' }, { children: _jsx("ul", Object.assign({ className: 'office_rows' }, { children: areas.map((v) => (_jsx("li", { children: `・${v.text}` }, v.key))) })) }))] })));
};
ProfessionalUnitCompanyInformationArea.propTypes = {
    area: propStr().isRequired,
};
export default ProfessionalUnitCompanyInformationArea;
